import {
    Component,
    ContentChild,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges, TemplateRef,
    ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';

@Component({
    selector: 'app-listbox',
    templateUrl: './listbox.component.html',
    styleUrls: ['./listbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ListboxComponent,
            multi: true
        }
    ],
})
export class ListboxComponent implements OnInit, ControlValueAccessor, OnChanges {

    _items = [];
    @Input() label = '';
    @Input() name = '';
    @Input() displayField = 'name';
    @Input() labelClass = {};
    @Input() valueClass = {};
    @Input() labelStyle = {};
    @Input() valueStyle = {};
    @Input() isMaterial = true;
    @Input() emptyMessage = 'generic.table.noRecords';
    @Input() multiple = false;
    @Input() formControl: UntypedFormControl = new UntypedFormControl();
    @Input() editMode = false;
    @Input() isLoading = false;
    @Input() template: 'item' | 'lift' = 'item';
    @HostBinding('class.selectable') @Input() selectable = false;

    @Output() select = new EventEmitter<any>();

    @ContentChild('custom', {static: false}) custom!: TemplateRef<any>;

    _value = null;

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;
        this.select.emit(this.value);
    }

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    constructor() {
    }

    ngOnInit() {

    }

    @Input()
    set items(items) {
        this._items = items;
    }

    get items() {
        return this._items;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    writeValue(obj: any): void {
        this.value = obj;
    }

    ngOnChanges(changes: SimpleChanges): void {

    }

    get currentTemplate() {
        return this.template;
    }

}
